
export default {
  name: 'BaseProfileAuthorHeader',
  props: {
    author: {
      type: Object,
      required: true,
    },
    statistics: {
      type: Object,
      required: true,
    },
  },
  computed: {
    authorRole() {
      if (this.author) {
        return this.author.type === 'COMPANY'
          ? 'BaseProfileAuthorCompanyHeader'
          : 'BaseProfileAuthorUserHeader'
      } else {
        return 'BaseProfileAuthorUserHeader'
      }
    },
  },
}
